export default "__VITE_ASSET__B1H$PbML__"